import { NgClass, NgTemplateOutlet } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterLink } from '@angular/router'
import {
  AnchorComponent,
  ButtonColor,
  ButtonComponent,
  ButtonDisplayType,
  IconComponent,
  TooltipDisplay,
  TooltipModule,
  TooltipPosition,
} from '@ftr/foundation'
import { FtrLogoComponent, LogoSize, LogoTheme, SideNavGroup } from '@ftr/ui-core'

@Component({
  selector: 'ftr-side-nav-display',
  templateUrl: './side-nav-display.component.html',
  styleUrls: ['./side-nav-display.component.css'],
  standalone: true,
  imports: [
    IconComponent,
    AnchorComponent,
    ButtonComponent,
    NgClass,
    TooltipModule,
    FtrLogoComponent,
    NgTemplateOutlet,
    RouterLink,
  ],
})
export class SideNavDisplayComponent {
  @Input() displayMode: 'DEFAULT' | 'OVERLAY' = 'DEFAULT'
  @Input() navGroups: SideNavGroup[] = []
  @Input() expanded: boolean = true
  @Output() toggleExpanded = new EventEmitter<void>()

  readonly buttonDisplayType = ButtonDisplayType
  readonly buttonColor = ButtonColor
  readonly tooltipPosition = TooltipPosition
  readonly tooltipDisplay = TooltipDisplay
  readonly logoSize = LogoSize
  readonly logoTheme = LogoTheme
}
